import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-table-not-found-content",
  templateUrl: "./table-not-found-content.component.html",
  styleUrls: ["./table-not-found-content.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableNotFoundContentComponent {}
